(() => {
  const COOKIE = 'ap_age_ok';
  const gate = document.getElementById('AgeGate');
  if (!gate) return;

  const readCookie = (name) =>
    document.cookie.split('; ').find((row) => row.startsWith(`${name}=`))?.split('=')[1];

  if (readCookie(COOKIE) === '1' || window.Shopify?.designMode) {
    return;
  }

  document.documentElement.classList.add('ap-age-locked');
  gate.hidden = false;

  gate.querySelector('[data-age-confirm]')?.addEventListener('click', () => {
    const expires = new Date();
    expires.setDate(expires.getDate() + 30);
    document.cookie = `${COOKIE}=1; expires=${expires.toUTCString()}; path=/; SameSite=Lax`;
    document.documentElement.classList.remove('ap-age-locked');
    gate.hidden = true;
  });
})();
